export function shouldShowHeaderCreateActions(hasItems: boolean, isMobile: boolean): boolean {
  return hasItems || !isMobile;
}
